import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useParams, useNavigate } from 'react-router-dom'
import { getData, putData } from '../../../actions/servicesHttp'
import Loading from '../../../components/generals/loading'
import { Toast } from 'primereact/toast'
import store from '../../../reducer/store'
import LockedDevices from '../../../components/modals/lockeds'
import ButtonsAndTables from '../../../components/Dashboards/Groups/buttonsAndTable'
import ModalGeneric from '../../../components/modals/modal'
import ConfigReportGroups from '../../../components/modals/configReportsGroup'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import SendMessages from '../../../components/modals/sendMessage'
import Header from '../../../components/generals/header'
import Swal from 'sweetalert2'
import $ from 'jquery'
import DataTableLazyDevices from '../../../components/generals/datatables/dataTableLazyDevices'
import SpeedDialMenu from '../../../components/Dashboards/speedDialMenu'
import ModalBackgroundChange from '../../../components/modals/modalBackgroundChange'
import ModalContentDownload from '../../../components/modals/modalContentDownload'
import stylesIndex from '../../../css/Index.module.css'
import ModalUseTimePreferences from '../../../components/modals/modalUseTimePreferences'
import ModalDeleteGroupPreference from '../../../components/modals/ModalDeleteGroupPreference'
import { formatDate, formatDateDenunciations } from '../../../components/generals/charts/utils/DatesFormats'
import ModalInstallApplications from '../../../components/modals/ModalInstallApplications'
import ModalUninstallApplications from '../../../components/modals/ModalUninstallApplications'
import { Button } from 'reactstrap'
import styles from '../../../css/Dashboards/DashDevices.module.css'
import ModalLeasingGroup from '../../../components/modals/ModalLeasingGroup'
import Info from '../../../components/Dashboards/info'
import { useTranslation } from 'react-i18next'
import { config } from '../../../config'

export default function DashboardGroup () {
  const { user } = store.getState()
  const { t } = useTranslation('dashboardGroup')
  const role = user.roles
  const toast = useRef(null)
  const { id } = useParams()
  const navigate = useNavigate()
  const [action, setAction] = useState(null)
  const [preferences, setPreferences] = useState(null)
  const [lease, setLease] = useState(null)
  const [data, setData] = useState(null)
  const [idsDevices, setIdsDevices] = useState(null)
  const [idsDevicesSend, setIdsDevicesSend] = useState(null)
  const [notGroup, setNotGroup] = useState({
    users: undefined,
    devices: undefined,
    geofences: undefined

  })
  const [reload, setReload] = useState(false)
  const [columnsRole] = useState([
    ...role?.devicesPage.columDataTableDevices
  ])
  const translatedColumns = columnsRole.map((col) => ({
    ...col,
    header: t(`items.${col.field}`)
  }))
  const columns = translatedColumns.filter((column) => column.field !== 'type' && column.field !== 'status_lock')

  const [selectedRows, setSelectedRows] = useState({
    users: [],
    addUsers: [],
    devices: [],
    addDevices: [],
    geofences: [],
    addGeofences: []
  })
  const [modalsShow, setModalsShow] = useState({
    name: false,
    message: false,
    locked: false,
    reports: false,
    useTimePreferences: false,
    deleteGroupPreference: false,
    addMembers: {
      addUsers: false,

      addDevices: false,
      addGeofences: false
    },
    installApplications: false,
    uninstallApplications: false,
    leasingGroup: false
  })

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await getDataGroup()
      await getPreferencesLocked(data)
      devicesSendMessage(selectedRows)
    }

    fetchData()
    membersNotGroup()
  }, [id, reload])

  useEffect(() => {
    getLease(id)
  }, [id])

  const getDataGroup = async () => {
    const response = await getData('group', id, navigate)
    if (response?.data?.devices?.length > 0) {
      const devices = response.data.devices
      devices.forEach((info) => {
        const soSplit = info.so.split('_-_')
        const so = `${soSplit[0]} ${soSplit[1]}`
        info.so = so
        const modelSplit = info.model.split('_-_')
        const model = `${modelSplit[0]} ${modelSplit[1]}`
        info.model = model
        if (info.last_date === null) {
          info.last_date = config?.backend?.ProjectStartDate
        } else {
          info.last_date = formatDate(info.last_date)
        }
      })
      response.data.devices = devices
    }
    setData(response.data)
    setIdsDevices(response.data.devices)
    setReload(false)

    return response
  }

  const getPreferencesLocked = async (x) => {
    const response = await getData('preferences', x?.preference?.id ?? 1, navigate)
    setPreferences(response.data)
  }

  const getLease = async (id) => {
    const response = await getData('lease', id, navigate)
    if (response?.data) {
      // const today = new Date().toISOString().split('T')[0]
      const data = response.data
      // if (data.startDate === today) data.state = 'en curso'
      // if (new Date(data.endDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) data.state = 'finalizado'
      // if (data.state === 'created') data.state = 'creado'
      setLease(data)
    }
  }

  function devicesSendMessage (selected) {
    const devices = selected.devices
    const ids = devices.map((device) => device.id)
    setIdsDevicesSend(ids)
  }

  function filterNotGroup (members) {
    const array = []
    members.forEach((member) => {
      if (member?.groups?.length === 0) {
        array.push(member)
      } else {
        const search = member?.groups?.find((item) => item.id === parseInt(id))
        if (search === undefined) {
          array.push(member)
        }
      }
    })

    return array
  }

  const filtered = (type, filters) => {
    const info = filters
    let selecteds
    if (type === 'users') {
      selecteds = selectedRows.users
    } else if (type === 'devices') {
      selecteds = selectedRows.devices
    // } else {
    } else if (type === 'geofences') {
      selecteds = selectedRows.geofences
    }
    for (const selected of selecteds) {
      if (type === 'users') {
        info.users = info.users.filter((item) => item.id !== selected.id)
      } else if (type === 'devices') {
        info.devices = info.devices.filter((item) => item.id !== selected.id)
      } else {
        info.geofences = info.geofences.filter((item) => item.id !== selected.id)
      }
    }
    const array = info
    return array
  }

  async function membersNotGroup () {
    const users = await getData('users', undefined, navigate)

    const geofences = await getData('geofences', undefined, navigate)
    let notUsers = filterNotGroup(users?.data)
    const notGeofences = filterNotGroup(geofences?.data)
    notUsers = notUsers.filter((item) => item.id !== 1)
    setNotGroup({ ...notGroup, users: notUsers, devices: undefined, geofences: notGeofences })
  }

  async function addMembers (type) {
    const group = data
    let newArray = []
    $('#btnModalSucess').prop('disabled', true)
    if (type === 'users') {
      if (selectedRows.addUsers.length === 0) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: t('message1'),
          showConfirmButton: false,
          timer: 1500
        })
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
      } else {
        if (group.users.length !== 0) {
          newArray = group.users
        }
        for (const selected of selectedRows.addUsers) {
          newArray.push(selected)
        }
        setSelectedRows({ ...selectedRows, addUsers: [], users: [] })
        group.users = newArray

        const response = await putData('groups', group, navigate)
        if (response.data.result) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: t('message2'),
            showConfirmButton: false,
            timer: 1500
          })
          setTimeout(() => {
            $('#btnModalSucess').prop('disabled', false)
          }, 1500)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: t('message3'),
            showConfirmButton: false,
            timer: 1500
          })
          setTimeout(() => {
            $('#btnModalSucess').prop('disabled', false)
          }, 1500)
        }
      }
    } else if (type === 'devices') {
      if (selectedRows.addDevices.length === 0) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: t('message4'),
          showConfirmButton: false,
          timer: 1500
        })
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
      } else {
        if (group?.devices.length !== 0) {
          newArray = group.devices
        }
        for (const selected of selectedRows.addDevices) {
          newArray.push(selected)
        }
        setSelectedRows({ ...selectedRows, addDevices: [], devices: [] })
        group.devices = newArray
        const response = await putData('groups', group, navigate)
        if (response.data.result) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: t('message2'),
            showConfirmButton: false,
            timer: 1500
          })
          setTimeout(() => {
            $('#btnModalSucess').prop('disabled', false)
          }, 1500)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: t('message3'),
            showConfirmButton: false,
            timer: 1500
          })
          setTimeout(() => {
            $('#btnModalSucess').prop('disabled', false)
          }, 1500)
        }
      }
    } else if (type === 'geofences') {
      if (selectedRows.addGeofences.length === 0) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: t('message5'),
          showConfirmButton: false,
          timer: 1500
        })
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
      } else {
        if (group.geofences.length !== 0) {
          newArray = group.geofences
        }
        for (const selected of selectedRows.addGeofences) {
          newArray.push(selected)
        }
        setSelectedRows({ ...selectedRows, addGeofences: [], geofences: [] })
        group.geofences = newArray

        const response = await putData('groups', group, navigate)

        if (response.data.result) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: t('message2'),
            showConfirmButton: false,
            timer: 1500
          })
          setTimeout(() => {
            $('#btnModalSucess').prop('disabled', false)
          }, 1500)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: t('message3'),
            showConfirmButton: false,
            timer: 1500
          })
          setTimeout(() => {
            $('#btnModalSucess').prop('disabled', false)
          }, 1500)
        }
      }
    }
    setReload(true)
    setModalsShow({
      ...modalsShow,
      addMembers: {
        addDevices: false,

        addUsers: false,
        addGeofences: false
      }
    })
    await membersNotGroup()
  }

  async function deleteMembers (type) {
    $('#btnModalSucess').prop('disabled', true)
    let titleMessage = ''
    if (type === 'users' && selectedRows.users.length === 0) {
      titleMessage = t('message6')
    } else if (type === 'devices' && selectedRows.devices.length === 0) {
      titleMessage = t('message7')
    } else if (type === 'geofences' && selectedRows.geofences.length === 0) {
      titleMessage = t('message8')
    }

    if (titleMessage !== '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: titleMessage,

        showConfirmButton: false,
        timer: 1500
      })
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
    } else {
      const filters = filtered(type, data)
      setSelectedRows({
        ...selectedRows,
        users: [],
        addUsers: [],
        devices: [],
        addDevices: [],
        geofences: [],
        addGeofences: []
      })
      const response = await putData('groups', filters, navigate)

      if (response.data.result) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: t('message9'),
          showConfirmButton: false,
          timer: 1500
        })
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: t('message10'),
          showConfirmButton: false,
          timer: 1500
        })
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
      }
      setReload(true)
      await membersNotGroup()
    }
  }

  function showAddMembers (type) {
    setModalsShow({
      ...modalsShow,
      addMembers: {
        ...modalsShow.addMembers,
        [type]: true
      }
    })
  }

  function handleModal (type, boolean) {
    if (type === 'desbloquear' || type === 'bloquear') {
      setAction(type)
      setModalsShow({ ...modalsShow, locked: boolean })
    } else {
      setModalsShow({ ...modalsShow, [type]: boolean })
    }
  }

  const handleChange = (data, type) => {
    setSelectedRows({
      ...selectedRows,
      [type]: data
    })
  }

  function closeModal (type) {
    setModalsShow({
      ...modalsShow,
      addMembers: {
        [type]: false
      }
    })
    setSelectedRows({
      users: [],
      addUsers: [],
      devices: [],

      addDevices: [],
      geofences: [],
      addGeofences: []
    })
    setIdsDevicesSend(null)
  }

  if (data === null || preferences === null) {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Loading color="primary" />
        </div>
      </div>
    )
  } else {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          {role?.dashboardGroupPage.buttonSpeedDial && <SpeedDialMenu
            onHide={handleModal}
            data={data}
            // deleted={deleted}
            idGroup={id}
            type="groups"
            dashboardGroupPage={role?.dashboardGroupPage}
          />}
          <Toast ref={toast} />
          <Header
            title={data.name}
            edit={true}
            data={data}
            type="group"
            reload={getDataGroup}
          />
          <div>
            <NavLink to="/mdm/groups">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button1')}
              </Button>
            </NavLink>
          </div>
          <div>
            {Object.keys(lease).length > 0 && <div>
              <h3 style={{ marginTop: '2rem' }}>{t('label1')}</h3>
              <div className={`${styles.infoLease}`}>
                  <Info
                    key="organization"
                    title={t('label2')}
                    value={lease.organization}
                    icon="fas fa-building"
                    className={`${styles.infoCard}`}
                  />
                  <Info
                    key="state"
                    title={t('label3')}
                    value={lease.state === 'created' ? t('label4') : lease.state === 'in progress' ? t('label5') : t('label6')}
                    icon="fas fa-flag"
                    className={`${styles.infoCard}`}
                  />
                  <Info
                    key="startDate"
                    title={t('label7')}
                    value={formatDateDenunciations(lease.startDate)}
                    icon="fas fa-clock"
                    className={`${styles.infoCard}`}
                  />
                  <Info
                    key="endDate"
                    title={t('label8')}
                    value={formatDateDenunciations(lease.endDate)}
                    icon="fas fa-clock"
                    className={`${styles.infoCard}`}
                  />
              </div>
            </div>}
            <h3 style={{ marginTop: '2rem' }}>{t('label9')}</h3>
            <ButtonsAndTables
              remove={() => deleteMembers('users')}
              add={() => showAddMembers('addUsers')}
              addBtn={role?.dashboardGroupPage.addUsers}
              removeBtn={role?.dashboardGroupPage.deleteUsers}
              exportPdf={false}
              exportsCsv={false}
              rowSelecteds={role?.dashboardGroupPage.selectRowsDataTableUsers}
              table="users"
              type="dataTableDemo"
              rowStates={false}
              actionDashboard={false}
              actionDelete={false}
              editUsers={false}
              search={['name', 'user', 'last', 'phone', 'email']}
              onSelecteds={handleChange}
              tableData={data.users}
              columns={[
                {
                  field: 'user',
                  header: t('headers.one')
                },
                {
                  field: 'name',
                  header: t('headers.two')
                },
                {
                  field: 'last',
                  header: t('headers.three')
                },
                {
                  field: 'phone',
                  header: t('headers.four')
                },
                {
                  field: 'email',
                  header: t('headers.five')
                }
              ]}
            />

            <h3 style={{ marginTop: '2rem' }}>{t('label10')}</h3>
            <ButtonsAndTables
              remove={() => deleteMembers('devices')}
              add={() => showAddMembers('devices')}
              addBtn={role?.dashboardGroupPage.addDevices}
              removeBtn={role?.dashboardGroupPage.deleteDevices}
              exportPdf={false}
              exportsCsv={false}
              rowSelecteds={role?.dashboardGroupPage.selectRowsDataTableDevices}
              table="devices"
              search={columns.map((el) => el.field)}
              rowStates={true}
              actionDashboard={false}
              actionDelete={false}
              editUsers={false}
              onSelecteds={handleChange}
              tableData={data.devices}
              type="dataTableDemo"
              columns={columns}
              columnStatus ={columnsRole}
            />

            <h3 style={{ marginTop: '2rem' }}>{t('label11')}</h3>
            <ButtonsAndTables
              remove={() => deleteMembers('geofences')}
              add={() => showAddMembers('addGeofences')}
              addBtn={role?.dashboardGroupPage.addGeofences}
              removeBtn={role?.dashboardGroupPage.deleteGeofences}
              exportPdf={false}
              exportsCsv={false}
              rowSelecteds={role?.dashboardGroupPage.selectRowsDataTableGeofences}
              table="geofences"
              type="dataTableDemo"
              rowStates={false}
              actionDashboard={false}
              actionDelete={false}
              editUsers={false}
              search={['name', 'description', 'type', 'place', 'date_order']}
              onSelecteds={handleChange}
              tableData={data.geofences}
              columns={[
                {
                  field: 'name',
                  header: t('headers.two')
                },
                {
                  field: 'description',
                  header: t('headers.six')
                },
                {
                  field: 'type',
                  header: t('headers.seven')
                },
                {
                  field: 'place',
                  header: t('headers.eight')
                },
                {
                  field: 'date_order',
                  header: t('headers.nine')

                }
              ]}
            />
          </div>

          {/* MODAL PARA AGREGAR USUARIOS */}
          <ModalGeneric
            show={modalsShow.addMembers.addUsers}
            onHide={() => closeModal('users')}
            size="xl"
            action="addUsers"
            id="addUsers"
            onClose={() => closeModal('users')}
            title={t('label12')}
            btnError={t('button2')}
            btnSuccess={t('button3')}
            actionSuccess={() => addMembers('users')}
          >
            <DataTableDemo
              data={notGroup.users}
              table="addUsers"
              actionDashboard={false}
              actionDelete={false}
              searchs={['name', 'user', 'last', 'phone', 'email']}
              rowStates={false}
              editUsers={false}
              onSelecteds={handleChange}
              columns={[
                {
                  field: 'user',
                  header: t('headers.one')
                },
                {
                  field: 'name',
                  header: t('headers.two')
                },
                {
                  field: 'last',
                  header: t('headers.three')
                },
                {
                  field: 'phone',
                  header: t('headers.four')
                },
                {
                  field: 'email',
                  header: t('headers.five')
                }
              ]}
            />
          </ModalGeneric>

          {/* MODAL PARA AGREGAR EQUIPOS */}
          <ModalGeneric
            show={modalsShow.addMembers.devices}
            onHide={() => closeModal('devices')}
            action="addDevices"
            id="addDevices"
            size="xl"
            onClose={() => closeModal('devices')}
            title={t('label13')}
            btnError={t('button2')}
            btnSuccess={t('button3')}
            actionSuccess={() => addMembers('devices')}
          >
            <DataTableLazyDevices
              table="addDevices"
              onSelecteds={handleChange}
              selectedRows={selectedRows.addDevices}
              groupId={id}
              exportsPdf={role?.devicesPage.exportPdfInDevices}
              exportsCsv={role?.devicesPage.exportCsvInDevices}
              rowSelecteds={role?.devicesPage.selectRowsDataTableInDevices}
              clearSelection={role?.devicesPage.selectRowsDataTableInDevices}
              actionDashboard={false}
              actionDelete={false}
              columnsRole={columnsRole}
            />
          </ModalGeneric>

          {/* MODAL PARA AGREGAR GEOCERCAS */}
          <ModalGeneric
            show={modalsShow.addMembers.addGeofences}
            onHide={() => closeModal('geofences')}
            size="xl"
            action="addGeofences"
            id="addGeofences"
            onClose={() => closeModal('geofences')}
            title={t('label14')}
            btnError={t('button2')}
            btnSuccess={t('button3')}
            actionSuccess={() => addMembers('geofences')}
          >
            <DataTableDemo
              data={notGroup.geofences}
              table="addGeofences"
              actionDashboard={false}
              actionDelete={false}
              searchs={['name', 'description', 'type', 'place', 'date_order']}
              rowStates={false}
              editUsers={false}
              onSelecteds={handleChange}
              columns={[
                {
                  field: 'name',
                  header: t('headers.two')
                },
                {
                  field: 'description',
                  header: t('headers.six')
                },
                {
                  field: 'type',
                  header: t('headers.seven')
                },
                {
                  field: 'place',
                  header: t('headers.eight')
                },
                {
                  field: 'date_order',
                  header: t('headers.nine')
                }
              ]}
            />
          </ModalGeneric>

          {/* MODAL CONFIGURACIONES DE REPORTES */}
          <ConfigReportGroups
            show={modalsShow.reports}
            onHide={() => handleModal('reports', false)}
          />

          {/* MODAL ENVIAR MENSAJE */}
          <SendMessages
            type="dashboardGroup"
            show={modalsShow.message}
            onHide={() => handleModal('message', false)}
            group={[parseInt(id)]}
            devices={idsDevicesSend}
            title={t('label15')}
            component="dashboardGroups"
          />

          {/* MODAL BLOQUEAR */}
          <LockedDevices
            show={modalsShow.locked}
            onHide={() => handleModal('locked', false)}
            action={action}
            title={`${t('label16')} ${action} ${t('label17')}`}
            devices={idsDevices}
            configDefault={preferences?.defaultThief?.default}
            preferences={preferences?.defaultThief}
          />

          {/* MODAL CAMBIO DE FONDO DE PANTALLA */}
          <ModalBackgroundChange
            show={modalsShow.backgroundChange}
            onHide={() => handleModal('backgroundChange', false)}
            title={t('label18')}
            btnError={t('button2')}
            btnSuccess={t('button4')}
            type="groups"
          />

          {/* MODAL DE DESCARGA DE CONTENIDO */}
          <ModalContentDownload
            show={modalsShow.contentDownload}
            onHide={() => handleModal('contentDownload', false)}
            title={t('label19')}
            btnError={t('button2')}
            btnSuccess={t('button4')}
            type="groups"
          />

          {/* MODAL DE PREFERENCIAS DE TIEMPO DE USO */}
          <ModalUseTimePreferences
            show={modalsShow.useTimePreferences}
            onHide={() => handleModal('useTimePreferences', false)}
            title={t('modalUseTimePreferences.title')}
            btnError={t('button2')}
            btnSuccess={t('button4')}
            group={[parseInt(id)]}
            useTimeId={preferences?.use_time?.id}
          />

          {/* MODAL DE ELIMINAR PREFERENCIAS DEL GRUPO */}
          <ModalDeleteGroupPreference
            show={modalsShow.deleteGroupPreference}
            onHide={() => handleModal('deleteGroupPreference', false)}
            title={t('label20')}
            btnError={t('button2')}
            btnSuccess={t('button4')}
            group={[parseInt(id)]}
          />

          {/* MODAL DE ARRENDAMIENTO DE LOS DISPOSITIVOS DEL GRUPO */}
          <ModalLeasingGroup
            show={modalsShow.leasingGroup}
            onHide={() => handleModal('leasingGroup', false)}
            title={t('modalLeasingGroup.title')}
            btnError={t('button2')}
            btnSuccess={t('button4')}
            groupId={parseInt(id)}
            reload={() => getLease(id)}
            lease={lease}
          />

          {/* MODAL DE INSTALACIÓN DE APLICACIONES */}
          <ModalInstallApplications
            show={modalsShow.installApplications}
            onHide={() => handleModal('installApplications', false)}
            title={t('modalApplications.title1')}
            btnError={t('button2')}
            btnSuccess={t('button6')}
            type="groups"
          />

          {/* MODAL DE DESINSTALACIÓN DE APLICACIONES */}
          <ModalUninstallApplications
            show={modalsShow.uninstallApplications}
            onHide={() => handleModal('uninstallApplications', false)}
            title={t('modalApplications.title2')}
            btnError={t('button2')}
            btnSuccess={t('button7')}
            type="groups"
          />
        </div>
      </div>
    )
  }
}
